import React from 'react';
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';



const ServicePage = () => {
    const servicesRaw = useSelector((state) => state.contents["services"]);

    const servicesList = Array.isArray(servicesRaw)
        ? servicesRaw
        : (servicesRaw?.result || servicesRaw?.data || []);
    useEffect(() => {
    AOS.init({
        once: true, // Animation happens only once
        duration: 1000,
    });
}, []);
    return (
        <React.Fragment>
            <section className="section py-5 bg-light bg-opacity-50">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={7}>
                            <div className="section-title text-center mb-5" data-aos="fade-up">
                                <h6 className="text-primary text-uppercase fw-bold ls-1 mb-2">Our Offerings</h6>
                                <h2 className="title mb-3 fw-bold">
                                    Empowering Hospitality Excellence through <span className="text-primary"> Our Trusted Services</span>
                                </h2>
                                <p className="text-muted mx-auto" style={{ maxWidth: '600px' }}>
                                    Connecting hospitality talent with the right opportunities—empowering
                                    employers to hire faster and job seekers to grow their careers.
                                </p>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        {servicesList.map((service, key) => (
                            <Col 
                                lg={4} 
                                md={6} 
                                key={'service-' + key} 
                                className="mb-4"
                                // AOS properties for staggered entrance
                                data-aos="fade-up" 
                                data-aos-delay={key * 100} 
                                data-aos-duration="800"
                            >
                                <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden service-card-custom">
                                    <div className="bg-primary opacity-75" style={{ height: '4px' }}></div>

                                    <CardBody className="p-4 d-flex flex-column">
                                        <div className="service-icon-container mb-4 d-inline-flex align-items-center justify-content-center rounded-4 bg-primary bg-opacity-10"
                                            style={{ width: '70px', height: '70px', transition: '0.3s' }}>
                                            <Icon
                                                icon={service?.icon || "solar:settings-bold-duotone"}
                                                color="#387ed8"
                                                width="36"
                                            />
                                        </div>

                                        <div className="mb-auto">
                                            <h5 className="fw-bold text-dark mb-3">{service?.name || "Service Name"}</h5>
                                            <p className="text-muted lh-base" style={{ fontSize: '0.95rem' }}>
                                                {service?.shortDescription || service?.content}
                                            </p>
                                        </div>

                                        <div className="mt-4 pt-3 border-top border-light">
                                            <Link
                                                to={service?.url || "#"}
                                                className="btn btn-link p-0 text-primary fw-bold text-decoration-none d-flex align-items-center"
                                            >
                                                Learn More
                                                <Icon icon="solar:alt-arrow-right-bold-duotone" className="ms-2" width="20" />
                                            </Link>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>

                <style>
                    {`
                    .service-card-custom {
                        transition: all 0.3s ease-in-out;
                    }
                    .service-card-custom:hover {
                        transform: translateY(-10px);
                        box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
                    }
                    .service-card-custom:hover .service-icon-container {
                        background-color: #387ed8 !important;
                    }
                    .service-card-custom:hover .service-icon-container svg {
                        color: #ffffff !important;
                        filter: brightness(0) invert(1);
                    }
                    `}
                </style>
            </section>
        </React.Fragment>
    );
};

export default ServicePage;
